import React from "react";
import { Heart, Bell, Menu, UserRound } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { SearchBox } from "@/components/site/SearchBox";
import { TranslateMenu, LanguageMenu } from "@/components/site/LanguagePicker";
import { NavMega } from "@/components/site/NavMega";
import { T } from "@/context/LanguageContext";

export function SiteHeader() {
  return (
    <>
      <header className="relative z-30">
      {/* Utility bar (scrolls away) */}
      <div className="bg-parchment/95 backdrop-blur border-b border-navy/10">
        <div className="mx-auto flex max-w-[1500px] items-center justify-between px-4 py-1.5 text-navy">
          <div className="text-[12px]">
            <span className="text-navy/70">Welcome to </span>
            <span className="font-bold text-oldglory-red">USAPulse.net</span>
          </div>
          <div className="flex items-center gap-5 rounded-b-none">
            <div className="hidden items-center gap-5 sm:flex [&_button]:!text-navy [&_button:hover]:!text-oldglory-red">
              <TranslateMenu />
              <span className="h-4 w-px bg-navy/20" />
              <LanguageMenu />
            </div>
            <span className="hidden h-4 w-px bg-navy/20 sm:block" />
            <button className="flex items-center gap-1.5 text-navy hover:text-oldglory-red transition-colors" data-testid="login-btn">
              <UserRound className="h-4 w-4" />
              <span className="text-[13px] font-medium"><T>Login / Register</T></span>
            </button>
          </div>
        </div>
      </div>

      {/* Logo + search */}
      <div className="bg-white border-b border-border">
        <div className="mx-auto flex max-w-[1500px] items-center gap-3 px-4 py-3 sm:gap-6">
          <Logo />
          <div className="hidden flex-1 lg:block">
            <SearchBox />
          </div>
          <div className="ml-auto flex items-center gap-3 sm:gap-5">
            <IconLink icon={<Heart className="h-5 w-5" />} label="My Favorites" testid="favorites-link" />
            <IconLink icon={<Bell className="h-5 w-5" />} label="Notifications" testid="notifications-link" />
            <IconLink icon={<Menu className="h-5 w-5" />} label="More" testid="more-link" />
          </div>
        </div>
        <div className="px-4 pb-3 lg:hidden"><SearchBox testid="global-search-input-mobile" /></div>
      </div>
      </header>

      {/* Primary nav — scrolls naturally with the page (no fixed frame) */}
      <div className="relative z-40" data-testid="primary-nav-wrap">
        <NavMega />
      </div>
    </>
  );
}

function IconLink({ icon, label, testid }) {
  return (
    <button className="flex flex-col items-center gap-0.5 text-navy transition-colors hover:text-oldglory-red" data-testid={testid}>
      <span className="text-oldglory-red">{icon}</span>
      <span className="hidden text-[10px] font-medium leading-none sm:block"><T>{label}</T></span>
    </button>
  );
}
